import React, { useEffect, useRef, useState } from "react";
import { Button, Col, Container, Card, Row, CardBody, Input, FormGroup, Label } from "reactstrap";
import { Link, useNavigate, useSearchParams, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getDivisionStart, getFeedbackList, getParentsToStaffFeddbacks } from "store/actions";
import moment from "moment";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import Spinners from "components/Common/Spinner";
import axios from "axios";

const FeedBack = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const [searchParams] = useSearchParams();
  const selectedTab = searchParams.get("selected-tab");
  const isOldMessages = searchParams.get("is-old");

  const { feedbacklist, errors, successMsg, Loading } = useSelector(
    state => state.FeedBackReducer
  )
  const [feedbackType, setFeedbackType] = useState("Parents to Admin");


  const [isOldFeedback, setIsOldFeedBack] = useState('1');
  const [sortedFeedbackList, setSortedFeedbackList] = useState([]);

  const PARENT_ORIGIN = 'https://pmapp.prisms.in/';

  window.addEventListener('message', event => {
    const host = event.origin;
    const parts = host.split('.');
    const rootDomain = parts.slice(-2).join('.');

    console.log(rootDomain);

    // 1️⃣ Security check
    if (rootDomain === PARENT_ORIGIN) return;

    const { action, items } = event.data;
    if (action === 'bulkSet' && typeof items === 'object') {
      // 2️⃣ Loop through and store each item
      Object.entries(items).forEach(([key, value]) => {
        // Ensure everything is a string
        localStorage.setItem(key, String(value));
      });

      // 3️⃣ Send back a simple acknowledgment
      event.source.postMessage(
        { status: 'ok', storedKeys: Object.keys(items) },
        event.origin
      );
    }
  });

  useEffect(() => {
    if (successMsg && successMsg !== null) {
      toast.success(successMsg)
    }
  }, [successMsg])

  useEffect(() => {
    if (feedbackType === "Parents to Admin") {
      dispatch(getFeedbackList())
    } else if (feedbackType === "Parents to Teachers") {
      dispatch(getParentsToStaffFeddbacks({}))
    }
  }, [feedbackType])


  useEffect(() => {
    if (selectedTab && selectedTab !== "") {
      setFeedbackType(selectedTab);
    }
  }, [selectedTab])


  const changeTab = (tabName) => {
    const routeName = location.pathname;
    console.log(routeName)
    navigate(`${routeName}?selected-tab=${tabName}`)
  }



  const redirectToChats = (feedback) => {
    console.log(`Navigating to: ${location.pathname}/chats`);
    navigate(`${location.pathname}/chats`, {
      state: {
        conversationID: feedback.conversation_id,
        chatSubject: feedback.subject,
        msg_to: feedback?.msg_to || null,
        from_name: feedback?.from_name || null,
        from_id: feedback?.from_id || null, // for ADMIN to view conversation of parents to teachers
        student_name: feedback?.student_name || null,
        staff_name: feedback?.staff_name || null,
        feedbackType: feedbackType,
        div_name: feedback.div_name,
      },
    });
  };


  const renderDate = (dateNum) => {

    const returnDate = (timestamp) => {

      return moment.utc(timestamp).format("DD/MM/YYYY"); // Ensure no timezone shift
    };

    return returnDate(dateNum);
  };


  useEffect(() => {
    const handlePopState = () => {
      navigate("/dashboard");
    };

    window.addEventListener("popstate", handlePopState);


    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [navigate]);

  useEffect(() => {
    if (isOldMessages && isOldMessages !== null) {
      setIsOldFeedBack(isOldMessages)
    }
  }, [isOldMessages])

  const changeIsOldMesg = (tabName) => {
    const queryParams = new URLSearchParams(location.search);

    queryParams.set('is-old', tabName); // update param1
    navigate(`${location.pathname}?${queryParams.toString()}`);
  }




  useEffect(() => {
    let newList = [];

    const sortByTimestampDesc = (array) => {
      return array.sort((a, b) => new Date(b.latest_msg_updatedDate) - new Date(a.latest_msg_updatedDate));
    };

    if (localStorage.getItem("group_id") == 10 && isOldFeedback == "1") {
      for (let i = 0; i < feedbacklist?.length; i++) {
        if (feedbacklist[i].new_or_old_status === "New") {
          newList.push(feedbacklist[i])
        }
      }


    } else if (localStorage.getItem("group_id") == 10 && isOldFeedback == "0") {
      for (let i = 0; i < feedbacklist?.length; i++) {
        if (feedbacklist[i].new_or_old_status === "Old") {
          newList.push(feedbacklist[i])
        }
      }
    } else {
      newList = feedbacklist ? feedbacklist : []
    }

    setSortedFeedbackList(sortByTimestampDesc(newList))

  }, [feedbacklist, isOldFeedback])


  // Search Student and teacher name code
  const [searchedArray, setSearchedArray] = useState([])
  const [searchString, setSearchString] = useState("")

  useEffect(() => {
    const result = [];
    if (localStorage.getItem("group_id") == 10) {
      for (let i = 0; i < sortedFeedbackList.length; i++) {
        const entry = sortedFeedbackList[i];

        const searchFields = [
          feedbackType === "Parents to Admin" ? entry.from_name : entry.staff_name,
          entry.div_name,
          entry.student_name
        ];

        let matchFound = searchFields.some(field => {
          if (!field) return false;
          for (let j = 0; j < searchString.length; j++) {
            if (j >= field.length || field[j].toLowerCase() !== searchString[j].toLowerCase()) {
              return false;
            }
          }
          return true;
        });

        if (matchFound) result.push(entry);
      }
      setSearchedArray(result);
    } else {
      setSearchedArray(sortedFeedbackList);
    }

  }, [searchString, sortedFeedbackList, feedbackType]);


  const [allClassDiv, setAllClassDiv] = useState([])
  const getClassDivision = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_LIVE_API_URL}/api/tscommon/all-new-div`,
        {
          sid: localStorage.getItem("sid"),
        }
      )
      setAllClassDiv(res.data)
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    getClassDivision()
  }, [])

  const handleCreateFeedbackBtn = () => {

    const routePath = location.pathname;
    navigate(`${routePath}/create`)
  }


  return (
    <div className="page-content">


      <Container className="p-0">

        {
          localStorage.getItem("group_id") == 10 && // this section is only visible to admin

          <div className="d-flex mb-2 mx-0 border border-2 p-1 rounded-3 overflow-auto">

            <div
              className={`border border-2 p-2 rounded-5 ${feedbackType === 'Parents to Admin' ? 'bg-primary text-white' : ''}  text-nowrap `}
              onClick={() => changeTab("Parents to Admin")}
              style={{ cursor: 'pointer' }}
            >
              Parents to Admin
            </div>

            <div
              className={`border border-2 p-2 rounded-5 text-nowrap ${feedbackType === 'Parents to Teachers' ? 'bg-primary text-white' : ''}`}
              onClick={() => changeTab("Parents to Teachers")}
              style={{ cursor: 'pointer' }}
            >
              Parents to Teachers
            </div>

          </div>
        }


        {localStorage.getItem("group_id") == 10 && // this section is only visible to admin
          <div className="d-flex mb-2 mx-0 border border-2 p-1 rounded-3 overflow-auto">

            <div
              className={`border border-2 p-2 rounded-5 
              ${isOldFeedback == '1' ? 'bg-primary text-white' : ''}  text-nowrap `}
              onClick={() => changeIsOldMesg(1)}
              style={{ cursor: 'pointer' }}
            >
              New
            </div>

            <div
              className={`border border-2 p-2 rounded-5 text-nowrap 
              ${isOldFeedback == '0' ? 'bg-primary text-white' : ''}`}
              onClick={() => changeIsOldMesg(0)}
              style={{ cursor: 'pointer' }}
            >
              Replied
            </div>

          </div>
        }


        {localStorage.getItem("group_id") == 10 &&
          <Row>
            <Col md={6}>
              <Input
                placeholder={feedbackType === "Parents to Admin" ? "Search By Student Name" : "Search By Teacher Name"}
                onChange={(e) => setSearchString(e.target.value)} />
            </Col>

            <Col md={6}>
              <FormGroup>
                <Input
                  name='classdiv_id'
                  id='classdiv_id'
                  type='select'
                  placeholder='SELECT CLASS AND DIVISION'
                  onChange={(e) => setSearchString(e.target.value)}


                >
                  <option value={""}>SELECT CLASS AND DIVISION</option>
                  {allClassDiv.map((data, index) => (<option key={index} value={data.div_name}>{data.div_name}</option>))}
                </Input>
              </FormGroup>
            </Col>
          </Row>

        }

        {
          Loading ? <Spinners /> :
            <Card className="p-2">
              <CardBody className="p-1">
                <div className="">
                  {sortedFeedbackList.length > 0 ? (
                    searchedArray.map((feedback, index) => (
                      <div
                        key={index}
                        onClick={() => redirectToChats(feedback)}
                        //  to={"/feedback/chats"}
                        // state={{
                        //   conversationID: feedback.conversation_id,
                        //   chatSubject: feedback.subject,
                        //   from_id: feedback?.from_id ? feedback?.from_id : null, //for ADMIN to view conversation of parents to teachers 
                        //   feedbackType
                        // }}
                        className="chat-contact-link"
                      >
                        <Row className="chat-contact">
                          <Col
                            xs={12}
                            className={`d-flex flex-column justify-content-center ${feedback.read_status === 'Unread' ? 'fw-bold' : ''}`}
                          >
                            <div className="w-100">
                              <div className="d-flex justify-content-between">
                                <p
                                  style={{ fontSize: "1.1rem" }}
                                  className="p-0 m-0 chat-contact-subject"
                                >
                                  {feedback.subject}
                                </p>
                                <p className="p-0 m-0 text-secondary chat-contact-date">
                                  {renderDate(feedback.createdDate)}
                                </p>
                              </div>
                              {
                                feedbackType === "Parents to Teachers" ?

                                  <div className="">
                                    <p className="p-0 m-0 text-secondary chat-contact-to">
                                      From: {feedback.student_name} - {feedback.div_name}
                                    </p>

                                    <p className="p-0 m-0 text-secondary chat-contact-to">
                                      To: {feedback.staff_name}
                                    </p>
                                  </div>
                                  :
                                  <div className="">
                                    <p className="p-0 m-0 text-secondary chat-contact-to">
                                      {localStorage.getItem("group_id") == 2 //Group ID 2 is for student login. Here showing message to staff or admin to student.
                                        ? `To: ${feedback.msg_to}` // Admin / Staff
                                        : `From: ${feedback.from_name} - ${feedback.div_name}` // This is for teacher and admin login where we showing who created feedback.
                                      }
                                    </p>
                                  </div>
                              }

                            </div>
                          </Col>
                        </Row>
                      </div>
                    ))
                  ) : <p className="text-center m-0">There are no feedback messages present</p>}
                </div>

                {localStorage.getItem("group_id") &&
                  localStorage.getItem("group_id") == 2 && (
                    <div
                      className="fixed-bottom"
                      style={{ zIndex: 0, marginBottom: "6%" }}
                    >
                      <Button
                        className="btn-rounded mb-5 me-3 btn-lg float-end"
                        color="primary"
                        onClick={handleCreateFeedbackBtn}
                      >
                        New Feedback{" "}
                      </Button>
                    </div>
                  )}
              </CardBody>
            </Card>
        }
      </Container>

    </div>

  )
}

export default FeedBack
